import isEmpty from 'lodash/isEmpty';
import { ROUTE_PREFIX_PRE_APPT, ROUTES_PRE_APPT } from '../constants/routes';
import { PAYMENT_STATUS } from '../constants/preApptConstants';

export const resolvePreApptRedirectPath = (workflowId, workflow) => {
  const { appointment, payment } = workflow || {};
  const paymentStatus = payment?.currentStatus?.status;

  if (paymentStatus === PAYMENT_STATUS.PAID) {
    return `${ROUTE_PREFIX_PRE_APPT}/${workflowId}${ROUTES_PRE_APPT.FINISH_PAYMENT}`;
  }

  if (
    isEmpty(appointment) ||
    isEmpty(payment) ||
    isEmpty(payment.paymentInfo) ||
    !isEmpty(paymentStatus)
  ) {
    return `${ROUTE_PREFIX_PRE_APPT}/${workflowId}${ROUTES_PRE_APPT.NO_APPT}`;
  }

  return null;
};
